import { v4 as uuid } from "uuid";

const getUUID = () => uuid().replace(/-/gi, "_");

export default getUUID;
